import React from "react";
import { FaCalendarAlt, FaClock, FaUser } from "react-icons/fa";
import "./EventActivityDetails.scss";

const EventActivityDetails = ({
  title,
  status,
  date,
  duration,
  person,
  price,
}) => {
  return (
    <div className="event-activity-details">
      <div className="event-activity-details__header">
        <div className="event-activity-details__status">
          <span
            className={`status-badge status-badge--${
              status?.toLowerCase() || "demo"
            }`}
          >
            Status: {status || "Demo"}
          </span>
        </div>
      </div>

      <div className="event-activity-details__content">
        <h2 className="event-activity-details__title">{title}</h2>

        <div className="event-activity-details__info">
          {date && (
            <div className="info-item">
              <FaCalendarAlt className="info-icon" />
              <span>{date}</span>
            </div>
          )}
          {duration && (
            <div className="info-item">
              <FaClock className="info-icon" />
              <span>{duration}</span>
            </div>
          )}
          {person && (
            <div className="info-item">
              <FaUser className="info-icon" />
              <span>{person}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventActivityDetails;
